/**
 * Dentis Rebuy Add-on Product Filter
 * Supports two modes:
 * 1) Multi-cross-sell (default): no variant filtering, show all cards
 * 2) Variant-aware filtering: map selected variant -> visible product indexes
 */

(function() {
  'use strict';

  const upsellWrapper = document.querySelector('.dentis-bundle-picker-upsell[data-rebuy-widget-id]');
  const wrapperDataset = upsellWrapper && upsellWrapper.dataset ? upsellWrapper.dataset : {};
  const WIDGET_ID = wrapperDataset.rebuyWidgetId || '275112';
  const ENABLE_VARIANT_FILTER = wrapperDataset.variantFilterEnabled === 'true';
  const AUTO_SELECT_PRIMARY_PRODUCT = wrapperDataset.autoSelectPrimary === 'true';
  const ALWAYS_VISIBLE_PRODUCT_INDEXES = parseIndexList(wrapperDataset.alwaysVisibleIndexes || '');
  const ALWAYS_VISIBLE_PRODUCT_IDS = parseIdList(
    wrapperDataset.alwaysVisibleProductIds || '10420658798886'
  );

  // Variant to product index mapping (used only when filtering is enabled)
  const VARIANT_PRODUCT_MAP = {
    50930393383206: 0, // Single Black (Musta / Aloituspaketti) -> Product 0
    50930393415974: 1, // Single White (Valkoinen / Aloituspaketti) -> Product 1
    50930393448742: 2  // Duo Pack (Musta ja valkoinen / Duopaketti) -> Product 2
  };
  const MAPPED_PRODUCT_INDEXES = Object.keys(VARIANT_PRODUCT_MAP).reduce((indexes, variantId) => {
    const mappedValue = VARIANT_PRODUCT_MAP[variantId];

    if (Array.isArray(mappedValue)) {
      mappedValue.forEach(index => {
        if (Number.isInteger(index)) indexes.push(index);
      });
    } else if (Number.isInteger(mappedValue)) {
      indexes.push(mappedValue);
    }

    return indexes;
  }, []);

  let hasInitialSyncCompleted = false;

  function parseIndexList(value) {
    if (!value) return [];
    return value
      .split(',')
      .map(token => parseInt(token.trim(), 10))
      .filter(index => Number.isInteger(index) && index >= 0);
  }

  function parseIdList(value) {
    if (!value) return [];
    return value
      .split(',')
      .map(token => parseInt(token.trim(), 10))
      .filter(id => Number.isInteger(id) && id > 0);
  }

  function getWidgetRoot() {
    const byId = document.getElementById(`rebuy-widget-${WIDGET_ID}`);
    if (byId && byId.tagName !== 'SCRIPT') return byId;

    const byClass = document.querySelector('.rebuy-widget.dentis-rebuy-addon');
    if (byClass && byClass.tagName !== 'SCRIPT') return byClass;

    return null;
  }

  function getVariantFromUrl() {
    const urlParams = new URLSearchParams(window.location.search);
    const variantParam = urlParams.get('variant');
    return variantParam ? parseInt(variantParam, 10) : null;
  }

  function resolveVariantIdFromDom() {
    const selectedInput =
      document.querySelector('input[name="id"]:checked') ||
      document.querySelector('input[name="id"]') ||
      document.querySelector('select[name="id"]');

    if (selectedInput && selectedInput.value) {
      const parsed = parseInt(selectedInput.value, 10);
      if (Number.isInteger(parsed)) return parsed;
    }

    const productJsonScript = document.querySelector('script[type="application/json"][id*="ProductJSON"]');
    if (productJsonScript) {
      try {
        const variants = JSON.parse(productJsonScript.textContent);
        const firstAvailable = variants.find(v => v.available) || variants[0];
        if (firstAvailable && firstAvailable.id) return firstAvailable.id;
      } catch (error) {
        console.warn('[Dentis Rebuy] Could not parse ProductJSON');
      }
    }

    const variantRadios = document.querySelector('variant-radios');
    if (variantRadios) {
      const variantData = variantRadios.querySelector('script[type="application/json"]');
      if (variantData) {
        try {
          const variants = JSON.parse(variantData.textContent);
          const firstAvailable = variants.find(v => v.available) || variants[0];
          if (firstAvailable && firstAvailable.id) return firstAvailable.id;
        } catch (error) {
          console.warn('[Dentis Rebuy] Could not parse variant-radios data');
        }
      }
    }

    return null;
  }

  function selectProduct(index) {
    if (!AUTO_SELECT_PRIMARY_PRODUCT) return;

    setTimeout(() => {
      const widget = getWidgetRoot();
      if (!widget) return;

      const productCards = widget.querySelectorAll('.rebuy-addon-card');
      const targetCard = productCards[index];
      if (!targetCard) return;

      if (!targetCard.classList.contains('is-selected')) {
        targetCard.click();
      }
    }, 150);
  }

  function getAlwaysVisibleIdIndexes(productCards) {
    if (!ALWAYS_VISIBLE_PRODUCT_IDS.length || !productCards || !productCards.length) return [];

    const visibleIds = new Set(ALWAYS_VISIBLE_PRODUCT_IDS);
    const indexes = [];

    productCards.forEach((card, index) => {
      const idValue = card.getAttribute('data-shopify-product-id');
      const productId = parseInt(idValue, 10);
      if (Number.isInteger(productId) && visibleIds.has(productId)) {
        indexes.push(index);
      }
    });

    return indexes;
  }

  function getUnmappedIndexes(productCards) {
    if (!productCards || !productCards.length) return [];

    const mappedSet = new Set(MAPPED_PRODUCT_INDEXES);
    const indexes = [];

    productCards.forEach((card, index) => {
      if (!mappedSet.has(index)) {
        indexes.push(index);
      }
    });

    return indexes;
  }

  function updateModernTemplate(visibleIndexes, primaryIndexes) {
    const widget = getWidgetRoot();
    if (!widget) return;

    const productCards = widget.querySelectorAll('.rebuy-addon-card');
    if (!productCards.length) return;

    const alwaysVisibleIdIndexes = getAlwaysVisibleIdIndexes(productCards);
    const shouldFilter = visibleIndexes instanceof Set;

    productCards.forEach((card, index) => {
      card.style.display = !shouldFilter || visibleIndexes.has(index) ? '' : 'none';
    });

    if (shouldFilter) {
      const primarySet = new Set(primaryIndexes);
      const idDrivenIndexes = alwaysVisibleIdIndexes.filter(index => !primarySet.has(index));
      const remainingIndexes = Array.from(visibleIndexes).filter(
        index => !primarySet.has(index) && !idDrivenIndexes.includes(index)
      );
      const orderedIndexes = [...primaryIndexes, ...idDrivenIndexes, ...remainingIndexes];

      productCards.forEach(card => {
        card.style.order = '';
      });

      orderedIndexes.forEach((index, order) => {
        if (productCards[index]) {
          productCards[index].style.order = String(order);
        }
      });
    } else {
      productCards.forEach(card => {
        card.style.order = '';
      });
    }

    if (AUTO_SELECT_PRIMARY_PRODUCT && primaryIndexes.length > 0) {
      const hasSelectedPrimary = primaryIndexes.some(
        index => productCards[index] && productCards[index].classList.contains('is-selected')
      );

      if (!hasSelectedPrimary) {
        const firstVisiblePrimary = primaryIndexes.find(
          index => productCards[index] && productCards[index].style.display !== 'none'
        );
        if (firstVisiblePrimary !== undefined) {
          selectProduct(firstVisiblePrimary);
        }
      }
    }
  }

  function updateLegacyTemplate(visibleIndexes) {
    const widget = getWidgetRoot();
    if (!widget) return;

    const rebuyItems = widget.querySelectorAll('.rebuy-addon__item');
    if (!rebuyItems.length) return;

    const shouldFilter = visibleIndexes instanceof Set;
    rebuyItems.forEach((item, index) => {
      const isVisible = !shouldFilter || visibleIndexes.has(index);
      item.classList.toggle('show', isVisible);
      item.style.display = isVisible ? 'flex' : 'none';
    });
  }

  function updateRebuyProducts(variantId) {
    if (!ENABLE_VARIANT_FILTER) {
      updateModernTemplate(null, []);
      updateLegacyTemplate(null);
      return;
    }

    const mapped = VARIANT_PRODUCT_MAP[variantId];
    const primaryIndexes = mapped === undefined ? [] : Array.isArray(mapped) ? mapped : [mapped];
    const hasMappedVariant = primaryIndexes.length > 0;

    /*
     * If the current variant is not in the map, do not hide cards.
     * This keeps the addon resilient when new variants/products are added.
     */
    if (!hasMappedVariant) {
      updateModernTemplate(null, []);
      updateLegacyTemplate(null);
      return;
    }

    const widget = getWidgetRoot();
    const productCards = widget ? widget.querySelectorAll('.rebuy-addon-card') : null;
    const alwaysVisibleIdIndexes = getAlwaysVisibleIdIndexes(productCards);
    const visibilitySet = new Set([
      ...primaryIndexes,
      ...ALWAYS_VISIBLE_PRODUCT_INDEXES,
      ...alwaysVisibleIdIndexes
    ]);
    const activeVisibilitySet = visibilitySet.size > 0 ? visibilitySet : null;

    updateModernTemplate(activeVisibilitySet, primaryIndexes);
    updateLegacyTemplate(activeVisibilitySet);
  }

  function handleVariantChange(event, isInitialLoad = false) {
    if (!ENABLE_VARIANT_FILTER) {
      updateRebuyProducts(null);
      if (isInitialLoad) hasInitialSyncCompleted = true;
      return;
    }

    let variantId = null;

    if (event && event.detail && event.detail.variant && event.detail.variant.id) {
      variantId = event.detail.variant.id;
    }

    if (!variantId) {
      variantId = getVariantFromUrl();
    }

    if (!variantId) {
      variantId = resolveVariantIdFromDom();
    }

    if (variantId) {
      updateRebuyProducts(variantId);
      if (isInitialLoad) hasInitialSyncCompleted = true;
    }
  }

  window.dentisRebuyUpdateProducts = function() {
    if (!hasInitialSyncCompleted) {
      handleVariantChange(null, true);
    } else {
      handleVariantChange();
    }
  };

  function tryInitialFilter(attempt) {
    var maxAttempts = 12;
    var widget = getWidgetRoot();
    if (widget && widget.querySelectorAll('.rebuy-addon-card').length > 0) {
      handleVariantChange(null, true);
      return;
    }
    if (attempt < maxAttempts) {
      setTimeout(function() { tryInitialFilter(attempt + 1); }, 500);
    }
  }

  function init() {
    if (ENABLE_VARIANT_FILTER) {
      document.body.addEventListener(
        'change',
        function(e) {
          if (e.target.matches('input[name="id"]') || e.target.matches('select[name="id"]')) {
            handleVariantChange({ detail: { variant: { id: parseInt(e.target.value, 10) } } });
          }
        },
        true
      );

      document.addEventListener('variant:changed', function(e) {
        if (e.detail && e.detail.variant) {
          handleVariantChange({ detail: { variant: e.detail.variant } });
        }
      });
    }

    tryInitialFilter(0);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

